import React from 'react'
import Navbar from '../containers/Navbar/Navbar.container'
import ManagementMenu from '../containers/ManagementMenu/ManagementMenu.container'
import routes from '../config/settings/routes'
import ProtectBySession from '../components/Security/ProtectBySession'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import { MapBoundary, ChoroplethMap } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem, Stack } from '@carbon/react'
import { Iframe } from '../containers/Map/Map.styles'
import { CardComponent, CardRow } from '../components/Layouts/Card.styles'
import Card from '../components/Layouts/Card';
import Typography from '../components/Basics/Typography'
import { Div } from '../components/Basics/Div.styles'

const TextWithIcon = ({ imageSrc, text }) => {
  return (
    <Div display="flex" $flexDirection="column" alignItems="center" gap="4px">
      <img width="60" height="32" src={imageSrc} alt={text} />
      <Typography className='cds--type-helper-text-01' textAlign="center">{text}</Typography>
    </Div>
  )
}

/**
 * The Map's Page.
 */
const Map = () => {
  const MapBreadCrumbs = () => {
    return (
      <Breadcrumb noTrailingSlash>
        <BreadcrumbItem>
          <a href="/#">Salar</a>
        </BreadcrumbItem>
        <BreadcrumbItem href="#" isCurrentPage>Mapa</BreadcrumbItem>
      </Breadcrumb>
    )
  }

  const title = 'Mapa'

  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
      <BrandLayout
        navbar={<Navbar managementMenu={<ManagementMenu current={routes.map} />} />}
        header={<Heading title={title} icon={<ChoroplethMap size={50} />} breadcrumbs={<MapBreadCrumbs />} tooltipContent='Módulo para el movimiento en tiempo real del rendimiento y la flota.' />}
      >
        <Stack gap={3}>
          <CardComponent width="100%" height="100%">
            <Card $justifyContent='flex-start'>
              <MapBoundary size={18} />
              <Typography className='cds--type-heading-compact-01'>
                MAPA DE SALAR
              </Typography>
            </Card>
            {/* <Card background="none">
              <Div display="flex" justifyContent="space-between" alignItems="center" gap="16px">
                <TextWithIcon imageSrc="/assets/icons/Bulldozer SurEste 1.svg" text="Bulldozer" />
                <TextWithIcon imageSrc="/assets/icons/Camión-Aljibe-agua.svg" text="Camión Aljibe" />
                <TextWithIcon imageSrc="/assets/icons/Camión Lubricador Combustible SurEste 1.svg" text="Camión Lubricador" />
                <TextWithIcon imageSrc="/assets/icons/Camión Pluma SurEste 1.svg" text="Camión Pluma" />
                <TextWithIcon imageSrc="/assets/icons/tolva_2.svg" text="Camión Tolva" />
                <TextWithIcon imageSrc="/assets/icons/Cargador Frontal.svg" text="Cargador Frontal" />
                <TextWithIcon imageSrc="/assets/icons/Excavadora SurEste 1.svg" text="Excavadora" />
                <TextWithIcon imageSrc="/assets/icons/Minibus_SurEste 1.svg" imageColor="red" text="Mini Bus" />
                <TextWithIcon imageSrc="/assets/icons/Motoniveladora SurEste 1.svg" text="Motoniveladora" />
                <TextWithIcon imageSrc="/assets/icons/Retroexcavadora SurEste 1.svg" imageColor="red" text="Retroexcavadora" />
                <TextWithIcon imageSrc="/assets/icons/Rodillo_SurEste 1.svg" text="Rodillo" />
                <TextWithIcon imageSrc="/assets/icons/Bus SurEste 1.svg" text="Bus" />
                <TextWithIcon imageSrc="/assets/icons/TRactocamión SurEste 1.svg" text="Tracto Camión" />
              </Div>
            </Card> */}
            <CardRow width='inherit'>
              <Card width='100%' $padding="0">
                <Iframe title="Monitoring map" src="https://grafana.terrestra.tech/d/ad9cf109-61fc-4cc5-a95d-10c393208726/mapa?orgId=1&refresh=5s&from=1750249907693&to=1750271507693&kiosk" width="100%" height="100%" />
              </Card>
            </CardRow>
          </CardComponent>
        </Stack>
      </BrandLayout>
    </ProtectBySession>
  )
}

export default Map
